import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Grunnforurensing from './Grunnforurensing.jsx'
import GrunnforurensingIcon from '../../../images/Forurensning2.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class GrunnforurensingList extends Component {
    state = {
        grunnforurensinger: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getGrunnforurensinger = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/grunnforurensing`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                grunnforurensinger: [...this.state.grunnforurensinger, ...data.grunnforurensinger],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
    }

    toggleGrunnforurensinger = () => {
        if (this.props.antall == 0) return

        if (this.state.grunnforurensinger.length == 0) {
            this.getGrunnforurensinger()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallGrunnforurensinger = this.state.continuationToken ? `${this.state.grunnforurensinger.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.toggleGrunnforurensinger}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={GrunnforurensingIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('grunnforurensinger')} ({antallGrunnforurensinger})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.grunnforurensinger.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.grunnforurensinger.map((g, index) => {return (<Grunnforurensing key={g.grunnforurensingId} grunnforurensing={g} antall={this.props.antall} isLast={index==this.state.grunnforurensinger.length-1} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getGrunnforurensinger}>
                                <span>{t('hent.grunnforurensinger')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(GrunnforurensingList)